// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoTable tr td:first-child {
  padding-right: 15px;
}

.sideBarButton {
  margin-bottom: 5px;
  height: 32px;
  width: auto;
  padding: 5px;
  background-color: white;
  border: 1px solid rgb(184, 184, 184);
  cursor: pointer;
}

.iacOutlineOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.65;
}

.notCompletedMark {
  position: absolute;
  border-radius: 9px;
  background: rgb(240, 123, 126);
  padding: 0;
  width: 9px;
  height: 9px;
  top: 0;
  right: -10px;
}

.questionnairesActive {
  color: rgb(233, 118, 6); /** rgb(240,123,126)*/
}

a.editInfo:hover {
  background-color: transparent;
  color: #6a6a6a;
}

div#sideBarTestOptions {
  margin: 0 auto 10px auto;
}

div.sideBarTestOptionsListBorder {
  border-bottom: 1px solid #bbb;
}

div#MPOSideBarPresentation h2 {
  margin-bottom: 0;
  padding-bottom: 0;
}

div#MPOSideBarPresentation h2#sideBarPortrait {
  margin-bottom: 12.5px;
}

div#sideBarTestOptions:last-child {
  margin-right: 0;
}

.date-display {
  font-size: 12px;
}

.topHead .pull-left {
  max-width: 340px;
}

/**
@media (max-height:  725px ) {
    #informations {
        display: none;
    }
    #informationAltTitle {
        display: block !important;
    }
}



#informationAltTitle {
    display: none;
}

*/
.topMenu, .bottomMenu {
  background-color: #eee;
  margin: 0 0 auto 102px;
  min-width: 550px;
}

.topMenu {
  padding-top: 20px;
  border-bottom: 1px solid #ddd;
  padding-left: 20px;
}

.bottomMenu {
  padding-top: 5px;
  border-top: 1px solid #ddd;
}

/** affixing **/
.top {
  background-color: rgb(241, 241, 241);
  top: 0;
}

.tRight {
  height: 100vh;
}

.fluid {
  position: relative;
  top: 125px;
}

.semiFluid {
  position: relative;
  top: 125px;
}

.blockBottom {
  position: fixed;
  padding-top: 20px;
}

.bbLeft {
  left: 102px;
  padding: 35px 20px 0 20px;
}

.bbRight {
  padding-right: 40px;
}

.cardEvaluation {
  width: 63px;
  height: 63px;
  margin: 0 auto;
}

.cardEvaluationTitle {
  font-size: 85%;
  text-align: center;
}

.report-text {
  font-size: 8pt;
  margin-right: 0;
  padding-right: 0;
  padding-left: 15px;
  text-align: justify;
}

#iacBox {
  background: white;
  border: 4px solid #cecece;
  padding: 20px;
  width: 100%;
}

#iacBox div, #iacBox h2, #iacBox .mb10 {
  display: block;
  margin-bottom: 10px;
}

.statusTag {
  color: white;
  font-weight: bold;
  font-size: 2rem;
  text-align: center;
  border-radius: 50px;
  width: 48px;
  height: 48px;
  padding: 15px 0 0 0;
}

.mat-darkGrayIcon {
  background: #666666 !important;
}

.mat-grayIcon {
  background: #aaaaaa !important;
}

.mat-orangeIcon {
  background: rgb(227, 94, 36) !important;
}

@media only screen and (max-width: 1234px) {
  .wrapGraphs {
    padding-right: 40px;
  }
}
::ng-deep .personLoading .backdrop, ::ng-deep .personLoading .spinner-three-bounce {
  z-index: 1999 !important;
}

::ng-deep .graph-container .mat-mini-fab {
  width: 25px;
  height: 25px;
  line-height: 24px;
}

::ng-deep .graph-container .mat-mini-fab .mat-button-wrapper {
  line-height: 10px;
  font-size: 12px;
  color: white;
}

::ng-deep .mat-tab-group.mat-primary .mat-ink-bar, .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  height: 2px; /* Adjust this to change the height of the ink bar */
}

::ng-deep .mat-tab-label {
  padding: 10px 25px; /* Adjust this to change the padding around the tab labels */
}

#peopleSidebar > mat-tab-header > .mat-mdc-tab-label-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.mdc-tab-indicator {
  height: 0px !important;
}

.menu-left {
  width: 300px;
  transform: translateX(0) !important;
}
.menu-left li > a {
  text-wrap: wrap;
}

.menu-right {
  width: 300px;
  transform: translateX(-220px) !important;
}
.menu-right li > a {
  text-wrap: wrap;
}

.activate-sherpa-container {
  position: relative;
  padding: 6px 13px 6px 17px;
  border-radius: 2px;
  background: #4D5056;
  margin-top: 15px;
}
.activate-sherpa-container .activate-sherpa-text {
  font-family: "Arial";
  color: #fff;
  font-size: 15px;
  line-height: 24px;
  padding: 4px 0;
}
.activate-sherpa-container .activate-sherpa-text .bold-jil {
  font-weight: 700;
}
.activate-sherpa-container .sherpa-nouveau {
  position: absolute;
  margin-top: 16px;
  top: -29px;
  left: 12px;
  border-radius: 18px;
  border: 1px solid #FFF;
  background: radial-gradient(221.49% 177.12% at -46.77% 47.5%, #DFDAD4 10.96%, #FE5E2C 48.6%, #575757 99.99%);
  padding: 3px 6px 4px 6px;
  color: #FFF;
  text-align: center;
  font-family: "Arial";
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.switch {
  display: inline-block;
  height: 23px;
  position: relative;
  width: 41px;
}

.switch input {
  display: none;
}

.slider {
  background-color: #F4F5F5;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: background-color 3s;
}

.slider:before {
  position: absolute;
  content: "";
  bottom: 4px;
  left: 4px;
  height: 15px;
  width: 15px;
  background-color: #292C32;
  filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));
  transition: background-color 3s, transform 3s;
}

.activate-sherpa-container .switch input:checked + .slider {
  background-color: #fff;
}

.activate-sherpa-container .switch input:checked + .slider:before {
  background-color: #FE5E2C;
  transform: translateX(18px);
  filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));
}

.slider.round {
  border-radius: 38px;
}

.slider.round:before {
  border-radius: 50%;
}

.selected-person-name-container {
  padding: 12px 15px 12px 12px;
  gap: 8px;
}
.selected-person-name-container .selected-person-circle {
  height: 16px;
  width: 16px;
  background-color: #DFE0E2;
  border-radius: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/web/people-sidebar/people-sidebar.component.scss"],"names":[],"mappings":"AAEA;EACI,mBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;AADJ;;AAIA;EACI,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;AADJ;;AAIA;EACI,uBAAA,EAAA,qBAAA;AADJ;;AAIA;EACI,6BAAA;EACA,cAAA;AADJ;;AAIA;EACI,wBAAA;AADJ;;AAIA;EACI,6BAAA;AADJ;;AAIA;EACI,gBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;;;;;;;;;;;;;;;;CAAA;AAkBA;EACI,sBAAA;EACA,sBAAA;EACA,gBAAA;AANJ;;AASA;EACI,iBAAA;EACA,6BAAA;EACA,kBAAA;AANJ;;AASA;EACI,gBAAA;EACA,0BAAA;AANJ;;AASA,eAAA;AAEA;EACI,oCAAA;EACA,MAAA;AAPJ;;AAUA;EACI,aAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,UAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,UAAA;AAPJ;;AAUA;EACI,eAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,WAAA;EACA,yBAAA;AAPJ;;AAUA;EACI,mBAAA;AAPJ;;AAUA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAPJ;;AAUA;EACI,cAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;AAPJ;;AAUA;EACI,cAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,8BAAA;AAPJ;;AAUA;EACI,8BAAA;AAPJ;;AAUA;EACI,uCAAA;AAPJ;;AAUA;EACI;IACI,mBAAA;EAPN;AACF;AAUA;EACI,wBAAA;AARJ;;AAWA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AARJ;;AAWA;EACI,iBAAA;EACA,eAAA;EACA,YAAA;AARJ;;AAWA;EACI,WAAA,EAAA,oDAAA;AARJ;;AAWA;EACI,kBAAA,EAAA,4DAAA;AARJ;;AAYA;EACI,uDAAA;AATJ;;AAYA;EACI,sBAAA;AATJ;;AAYA;EACI,YAAA;EACA,mCAAA;AATJ;AAUI;EACI,eAAA;AARR;;AAWA;EACI,YAAA;EACA,wCAAA;AARJ;AASI;EACI,eAAA;AAPR;;AAcA;EAEI,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAZJ;AAaI;EACI,oBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAXR;AAYQ;EACI,gBAAA;AAVZ;AAaI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,4GAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAXR;;AAgBA;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAbJ;;AAgBE;EACE,aAAA;AAbJ;;AAgBE;EACE,yBAAA;EACA,SAAA;EACA,eAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,+BAAA;AAbJ;;AAgBE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,sDAAA;EAEA,6CAAA;AAdJ;;AAiBE;EACE,sBAAA;AAdJ;;AAiBE;EACE,yBAAA;EACA,2BAAA;EACA,sDAAA;AAdJ;;AAkBE;EACE,mBAAA;AAfJ;;AAkBE;EACE,kBAAA;AAfJ;;AAkBE;EACE,4BAAA;EACA,QAAA;AAfJ;AAgBM;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AAdR","sourcesContent":["@use \"src/responsive\" as responsive;\n\n.infoTable tr td:first-child {\n    padding-right: 15px;\n}\n\n.sideBarButton {\n    margin-bottom: 5px;\n    height: 32px;\n    width: auto;\n    padding: 5px;\n    background-color: white;\n    border: 1px solid rgb(184, 184, 184);\n    cursor: pointer;\n}\n\n.iacOutlineOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: white;\n    opacity: 0.65;\n}\n\n.notCompletedMark {\n    position: absolute;\n    border-radius: 9px;\n    background: rgb(240,123,126);\n    padding: 0;\n    width: 9px;\n    height: 9px;\n    top: 0;\n    right: -10px;\n}\n\n.questionnairesActive {\n    color: rgb(233,118,6); /** rgb(240,123,126)*/\n}\n\na.editInfo:hover {\n    background-color: transparent;\n    color: #6a6a6a;\n}\n\ndiv#sideBarTestOptions {\n    margin: 0 auto 10px auto;\n}\n\ndiv.sideBarTestOptionsListBorder {\n    border-bottom: 1px solid #bbb;\n}\n\ndiv#MPOSideBarPresentation h2 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\ndiv#MPOSideBarPresentation h2#sideBarPortrait {\n    margin-bottom: 12.5px;\n}\n\ndiv#sideBarTestOptions:last-child {\n    margin-right: 0;\n}\n\n.date-display {\n    font-size: 12px;\n}\n\n.topHead {\n    // height: 64px;\n}\n\n.topHead .pull-left {\n    max-width: 340px;\n}\n\n/**\n@media (max-height:  725px ) {\n    #informations {\n        display: none;\n    }\n    #informationAltTitle {\n        display: block !important;\n    }\n}\n\n\n\n#informationAltTitle {\n    display: none;\n}\n\n*/\n\n.topMenu, .bottomMenu {\n    background-color: #eee;\n    margin: 0 0 auto 102px;\n    min-width: 550px;\n}\n\n.topMenu {\n    padding-top: 20px;\n    border-bottom: 1px solid #ddd;\n    padding-left: 20px;\n}\n\n.bottomMenu {\n    padding-top: 5px;\n    border-top: 1px solid #ddd;\n}\n\n/** affixing **/\n\n.top {\n    background-color: rgb(241, 241, 241);\n    top: 0;\n}\n\n.tRight {\n    height: 100vh;\n}\n\n.fluid {\n    position: relative;\n    top: 125px;\n}\n\n.semiFluid {\n    position: relative;\n    top: 125px;\n}\n\n.blockBottom {\n    position: fixed;\n    padding-top: 20px;\n}\n\n.bbLeft {\n    left: 102px;\n    padding: 35px 20px 0 20px;\n}\n\n.bbRight {\n    padding-right: 40px;\n}\n\n.cardEvaluation {\n    width: 63px;\n    height: 63px;\n    margin: 0 auto;\n}\n\n.cardEvaluationTitle {\n    font-size: 85%;\n    text-align: center\n}\n\n.report-text {\n    font-size: 8pt;\n    margin-right: 0;\n    padding-right: 0;\n    padding-left: 15px;\n    text-align: justify;\n}\n\n#iacBox {\n    background: white;\n    border: 4px solid #cecece;\n    padding: 20px;\n    width: 100%;\n}\n\n#iacBox div, #iacBox h2, #iacBox .mb10 {\n    display: block;\n    margin-bottom: 10px;\n}\n\n.statusTag {\n    color: white;\n    font-weight: bold;\n    font-size: 2rem;\n    text-align: center;\n    border-radius: 50px;\n    width: 48px;\n    height: 48px;\n    padding: 15px 0 0 0;\n}\n\n.mat-darkGrayIcon {\n    background: #666666 !important;\n}\n\n.mat-grayIcon {\n    background: #aaaaaa !important;\n}\n\n.mat-orangeIcon {\n    background: rgb(227, 94, 36) !important;\n}\n\n@media only screen and (max-width: 1234px) {\n    .wrapGraphs {\n        padding-right: 40px;\n    }\n}\n\n::ng-deep .personLoading .backdrop, ::ng-deep .personLoading .spinner-three-bounce {\n    z-index: 1999 !important;\n}\n\n::ng-deep .graph-container .mat-mini-fab {\n    width: 25px;\n    height: 25px;\n    line-height: 24px;\n}\n\n::ng-deep .graph-container .mat-mini-fab .mat-button-wrapper {\n    line-height: 10px;\n    font-size: 12px;\n    color: white;\n}\n\n::ng-deep .mat-tab-group.mat-primary .mat-ink-bar, .mat-tab-nav-bar.mat-primary .mat-ink-bar {\n    height: 2px; /* Adjust this to change the height of the ink bar */\n}\n\n::ng-deep .mat-tab-label {\n    padding: 10px 25px; /* Adjust this to change the padding around the tab labels */\n}\n\n\n#peopleSidebar > mat-tab-header > .mat-mdc-tab-label-container {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12)!important;\n}\n\n.mdc-tab-indicator {\n    height: 0px!important;\n}\n\n.menu-left {\n    width: 300px;\n    transform: translateX(0) !important;\n    li > a {\n        text-wrap: wrap;\n    }\n}   \n.menu-right {\n    width: 300px;\n    transform: translateX(-220px) !important;\n    li > a {\n        text-wrap: wrap;\n    }\n}\n\n//******************************************** */\n// Bouton SHERPA\n//******************************************** */\n.activate-sherpa-container {\n    // border: 1px solid #000;\n    position: relative;\n    padding: 6px 13px 6px 17px;\n    border-radius: 2px;\n    background: #4D5056;\n    margin-top: 15px;\n    .activate-sherpa-text {\n        font-family: 'Arial';\n        color: #fff;\n        font-size: 15px;\n        line-height: 24px;\n        padding: 4px 0;\n        .bold-jil {\n            font-weight: 700;\n        }\n    }\n    .sherpa-nouveau {\n        position: absolute;\n        margin-top: 16px;\n        top: -29px;\n        left: 12px;\n        border-radius: 18px;\n        border: 1px solid #FFF;\n        background: radial-gradient(221.49% 177.12% at -46.77% 47.5%, #DFDAD4 10.96%, #FE5E2C 48.6%, #575757 99.99%);\n        padding: 3px 6px 4px 6px;\n        color: #FFF;\n        text-align: center;\n        font-family: 'Arial';\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        \n    }\n}\n\n.switch {\n    display: inline-block;\n    height: 23px;\n    position: relative;\n    width: 41px;\n  }\n  \n  .switch input {\n    display:none;\n  }\n  \n  .slider {\n    background-color: #F4F5F5;\n    bottom: 0;\n    cursor: pointer;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    transition: background-color 3s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    bottom: 4px;\n    left: 4px;\n    height: 15px;\n    width: 15px;\n    background-color: #292C32;\n    filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));\n\n    transition: background-color 3s, transform 3s;\n  }\n  \n  .activate-sherpa-container .switch input:checked + .slider {\n    background-color: #fff;\n  }\n  \n  .activate-sherpa-container .switch input:checked + .slider:before {\n    background-color: #FE5E2C;\n    transform: translateX(18px);\n    filter: drop-shadow(0px 0px 5.5px rgba(0, 0, 0, 0.25));\n\n  }\n  \n  .slider.round {\n    border-radius: 38px;\n  }\n  \n  .slider.round:before {\n    border-radius: 50%;\n  }\n\n  .selected-person-name-container {\n    padding: 12px 15px 12px 12px;\n    gap: 8px;\n      .selected-person-circle {\n        height: 16px;\n        width: 16px;\n        background-color: #DFE0E2;\n        border-radius: 16px;\n      }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
